import store from '@/store';

const refDataActions = [
  'coordinatingCommittees/fetchCoordinatingCommittees',
  'countries/fetchCountries',
  'addressTypes/fetchAddressTypes',
  'genders/fetchGenders',
  'careerStages/fetchCareerStages',
  'industryAcademiaGovernment/fetchIndustryAcademiaGovernment',
  'positions/fetchPositions',
  'positions/fetchPositionsForLiaison',
  'trienniums/fetchTrienniums',
  'conferenceTypes/fetchConferenceTypes',
  'venueTypes/fetchVenueTypes',
];

function initRefData() {
  return Promise.allSettled(
    refDataActions.map((action) => store.dispatch(action)),
  );
}

export default initRefData;
